import { render } from "./TraderMultiselect.vue?vue&type=template&id=4f6e1c86&ts=true"
import script from "./TraderMultiselect.vue?vue&type=script&lang=ts"
export * from "./TraderMultiselect.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__